module.exports = __webpack_public_path__ + "img/9788958073857.8da4c50c.jpg";